import "./App.scss";
import "bulma/css/bulma.css";
import { Route, Switch, useLocation, useRouteMatch } from "react-router-dom";
import Header from "./commonComponents/Header";
import Footer from "./commonComponents/Footer";
import Home from "./AppComponents/Home";
import Game from "./AppComponents/Game";
import NotFound from "./AppComponents/NotFound";
import { useEffect, useState } from "react";
import SideMenu from "./AppComponents/SideMenu";
import ReactGA from "react-ga4";
import _ from "lodash";
import { reactLocalStorage } from "reactjs-localstorage";
import config, { getHeaders } from "./config";
import Category from "./commonComponents/Category";
import Profile from "./AppComponents/Profile";
import Unsubscribe from "./AppComponents/Unsubscribe";
import HomeLoader from "./AppComponents/HomeLoader";
import Leaderboard from "./commonComponents/Leaderboard";
import { initSession } from "./session";
import queryString from "query-string";
import SingleGame from "./commonComponents/PromoSingleGame";

function App() {
  const [sideMenu, setSideMenu] = useState(false);
  const [showSideMenu, setshowSideMenu] = useState(true);
  const [loading, setLoading] = useState(true);
  const [banners, setBanners] = useState([]);
  const [games, setGames] = useState([]);
  const match1 = useRouteMatch("/game/:id");
  const match2 = useRouteMatch("/singlegame/:title/:id");
  const [appConfigData, setappConfigData] = useState({});
  let { search } = useLocation();
  const { rcid, camp } = queryString.parse(search);
  console.log(">>>route match:::", match1, match2);
  useEffect(() => {
    initSession();
    if (camp) {
      sessionStorage.setItem("camp", camp);
      localStorage.setItem("camp", camp);
    }
    if (rcid) {
      sessionStorage.setItem("rcid", rcid);
      localStorage.setItem("rcid", rcid);
    }
  }, [rcid, camp]);
  useEffect(() => {
    ReactGA.initialize(config.get("ga_tag"));
    // Send pageview with a custom path
    ReactGA.send({
      hitType: "pageview",
      page: window.location.href + window.location.hash,
      title: "Page_Viewed",
    });
    getAppConfigData();
  }, []);

  const getAppConfigData = () => {
    const url = `${config.get("base")}${config.get("appConfig")}`;
    fetch(url, {
      method: "POST",
      body: JSON.stringify({
        mcc: "652",
        mnc: "04",
        uid: reactLocalStorage.get("uid") ? reactLocalStorage.get("uid") : "",
      }),
      headers: getHeaders(),
    })
      .then((res) => {
        if (!res.ok) {
          throw res;
        }
        return res.json();
      })
      .then(
        (result) => {
          console.log("result message appConfig ::", result);
          const appConfigObj = {
            menu: result.menu,
            menu_color: result.menu_color,
            home_logo: result.home_logo,
            menu_logo: result.menu_logo,
            sub_url: result.sub_url,
            menu: result.menu,
            menu_color: result.menu_color,
            home_logo: result.home_logo,
            menu_logo: result.menu_logo,
            view_all: result.view_btn_txt,
            bg_color: result.bkg_color,
            similar_txt: result.similar_cat_txt,
            play_btn: result.play_btn_txt,
            he_url: result.he_url,
            sub_url: result.sub_url,
            unsub_ok_txt: result.unsub_ok_txt,
            unsub_msg_txt: result.unsub_msg_txt,
            unsub_cancel_txt: result.unsub_cancel_txt,
            unsub_url: result.unsub_url,
            view_btn_color: result.cat_view_btn_bg_color,
            show_unSub: result.menu,
            flow: result.subRedirectFlow,
            term_url: result.terms,
          };

          setappConfigData(appConfigObj);
          setLoading(false);
          setGames(result.games_list);
          setBanners(result.banner);
          reactLocalStorage.set("unsub_txt", result.unsub_ok_txt);
          reactLocalStorage.set("sub_url", result.sub_url);
          reactLocalStorage.set("unsub_ok_txt", result.unsub_ok_txt);
          reactLocalStorage.set("unsub_msg_txt", result.unsub_msg_txt);
        },
        (error) => {
          console.log("error:::", error);
        }
      );
  };

  if (loading) return <HomeLoader />;

  if (!loading)
    return (
      <section className="hero is-fullheight bg" style={{ padding: "0px" }}>
        {!(match1 || match2) && (
          <Header
            handleClick={() => setSideMenu(!sideMenu)}
            home_logo={appConfigData.home_logo}
            menu_color={appConfigData.menu_color}
            sub_url={appConfigData.sub_url}
            view_btn_color={appConfigData.view_btn_color}
            showSideMenu={showSideMenu}
            sideMenu={sideMenu}
            menu_logo={appConfigData.menu_logo}
            setshowSideMenu={() => setshowSideMenu(!showSideMenu)}
          />
        )}
        <SideMenu
          menuColor={appConfigData.menu_color}
          menuLogo={appConfigData.menu_logo}
          sideMenu={sideMenu}
          handleClose={() => setSideMenu(!sideMenu)}
        />
        <Switch>
          <Route path="/home">
            <Home
              games={games}
              banners={banners}
              view_btn_color={appConfigData.view_btn_color}
              view_all={appConfigData.view_all}
              flow={appConfigData.flow}
              sub_url={appConfigData.sub_url}
              play_btn_txt={appConfigData.play_btn}
            />
          </Route>
          <Route exact path="/">
            <Home
              games={games}
              banners={banners}
              view_btn_color={appConfigData.view_btn_color}
              view_all={appConfigData.view_all}
              flow={appConfigData.flow}
              sub_url={appConfigData.sub_url}
              play_btn_txt={appConfigData.play_btn}
            />
          </Route>
          {/* <Route exact path="/subscribe">
          <Subscribe />
        </Route> */}
          {/* <Route path="/games">
          <Games allGames={allGames} />
        </Route> */}
          <Route path="/game/:title/:id">
            <Game
              btn_color={appConfigData.view_btn_color}
              similar_txt={appConfigData.similar_txt}
              play_btn_txt={appConfigData.play_btn}
              view_all={appConfigData.view_all}
            />
          </Route>
          <Route path="/singlegame/:title/:id">
            <SingleGame
              games={games}
              btn_color={appConfigData.view_btn_color}
              similar_txt={appConfigData.similar_txt}
              play_btn_txt={appConfigData.play_btn}
              view_all={appConfigData.view_all}
              sub_url={appConfigData.sub_url}
            />
          </Route>
          {/* <Route path="/freegames">
          <FreeGames />
        </Route> */}
          <Route path="/profile">
            <Profile />
          </Route>
          {/* <Route path="/login">
          <Mobile
            setshowSideMenu={() => {
              setshowSideMenu(false);
            }}
          />
        </Route>
        <Route path="/otp">
          <OTP
            setshowSideMenu={() => {
              setshowSideMenu(false);
            }}
          />
        </Route> */}
          <Route path="/category">
            <Category
              btn_color={appConfigData.view_btn_color}
              play_btn_txt={appConfigData.play_btn}
            />
          </Route>
          <Route path="/leaderboard">
            <Leaderboard />
          </Route>
          {/* <Route path="/terms&conditions">
                  <Terms url={appConfigData.term_url}/>
            </Route> */}
          <Route path="/unsub">
            <Unsubscribe unsub_mode={appConfigData.unsub_mode} />
          </Route>
          <Route path="*">
            <NotFound />
          </Route>
        </Switch>
        <Footer />
      </section>
    );
}
export default App;
